import najaInstance from 'naja';

export class AutoSubmitFormElementExtension {
    private timer: null | ReturnType<typeof setTimeout> = null;

    public constructor(naja: typeof najaInstance) {
        naja.addEventListener('load', () => {
            document.querySelectorAll('select[data-autosubmit]').forEach(element => {
                element.addEventListener('change', () => this.submitClosestForm(naja, element));
            });

            document.querySelectorAll('input[data-autosubmit]').forEach(element => {
                element.addEventListener('keyup', () => this.submitClosestForm(naja, element));
            });

            document.querySelectorAll('input[data-autosubmit]').forEach(element => {
                element.addEventListener('change', () => this.submitClosestForm(naja, element));
            });

            document.querySelectorAll('select[data-autosubmit-per-page]').forEach(element => {
                element.addEventListener('change', () => {
                    const parent = element.parentElement;

                    if (parent === null) {
                        return;
                    }

                    const button = parent.querySelector('input[type=submit]');

                    if (button === null) {
                        return;
                    }

                    naja.uiHandler.clickElement(button);
                });
            });
        });
    }

    private submitClosestForm(naja: typeof najaInstance, element: Element): void {
        const form = element.closest('form');

        if (form === null) {
            throw new Error('Element initialized for auto submit must be "form" or element inside form');
        }

        if (this.timer !== null) {
            clearTimeout(this.timer);
        }

        this.timer = window.setTimeout(() => naja.uiHandler.submitForm(form, {history: true}), 400);
    }
}
